import { HumanGreetingVariantIcon } from './HumanGreetingVariantIcon';

/**
 * author: Google
 * id 1C9856E1-6945-464E-85E7-A46C4A974C9D
 * name human-greeting-variant
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-greeting-variant.svg
 * tags
 * - People / Family 
 */
export const HumanHelloVariantIcon = HumanGreetingVariantIcon;
export default HumanHelloVariantIcon